/**
 * @file The display label of each receivable aging bucket a stored report run may still hold but
 * `ANALYTICS_AGING_BUCKETS` no longer names: `current` and `days1To30`, from before the first bucket
 * became 0 to 30 days past due. Consumers: the report run renderers, which show a frozen run as it
 * was written. Kept apart so `AnalyticsAgingBucket` names only the live buckets and no live answer
 * can carry a retired key.
 */

export const ANALYTICS_RETIRED_AGING_BUCKET_LABELS = {
  current: 'Current',
  days1To30: '1–30 days',
} as const satisfies Record<string, string>;
